import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4d9bc64f")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = {
  key: 0,
  class: "dcd"
}
const _hoisted_3 = {
  key: 1,
  class: "leader"
}
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "functions" }
const _hoisted_6 = {
  key: 0,
  class: "displayRow"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "Kick", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "t" }, "Make host", -1)
const _hoisted_9 = {
  key: 2,
  class: "displayRow"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Ripple = _resolveComponent("Ripple")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_ctx.player.name)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
      account:true,
      player: _ctx.player,
      small: _ctx.small,
      open: _ctx.open
    }),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.open=true))
      }, [
        _createVNode(_component_Ripple),
        (_ctx.player.avatar)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({icon:true, [_ctx.player.avatar]:true, _img:true})
            }, null, 2))
          : (_ctx.player)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass({icon:true, _img:true}),
                style: _normalizeStyle(`background-image: url(https://s3.ap-southeast-1.amazonaws.com/gochaseme/${_ctx.player.id}.jfif)`)
              }, null, 4))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          (_ctx.$store.state.GameView.lobby.players && _ctx.$store.state.GameView.lobby.players[_ctx.index] && _ctx.$store.state.GameView.lobby.players[_ctx.index].lastPing < new Date().getTime() - 10000 )
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_MovingIcon, {
                  name: "loader_spinner",
                  autoplay: true,
                  loop: true
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.player.id == _ctx.$store.state.GameView.lobby.meta.host)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_MovingIcon, {
                    hex: "#ffffff",
                    name: "crown",
                    type: "svg"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.player.name), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MovingIcon, {
            name: "more_vert",
            type: "svg"
          })
        ]),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "cover",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
            }))
          : _createCommentVNode("", true),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "popout",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
            }, [
              (_ctx.$store.state.Auth.user.id == _ctx.player.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " This is you "))
                : (_ctx.$store.state.Auth.user.id == _ctx.$store.state.GameView.lobby.meta.host)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", {
                        class: "row",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.kick()), ["stop"]))
                      }, [
                        _createVNode(_component_Ripple),
                        _hoisted_7
                      ]),
                      (_ctx.player.id!='fakie')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "row",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.promote()), ["stop"]))
                          }, [
                            _createVNode(_component_Ripple),
                            _hoisted_8
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, " You are not the host "))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}